import { render, staticRenderFns } from "./removeUndeliveredFromList.vue?vue&type=template&id=2057c571&"
import script from "./removeUndeliveredFromList.vue?vue&type=script&lang=ts&"
export * from "./removeUndeliveredFromList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports